import React from 'react';
import Reflux from 'reflux';
import {Button, message, Row, Col} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import {detail} from '../../service/thingsOrder';
import moment from 'moment';
import './table.css';

class ReturnGoodsPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // opts: ['回执单'],
            // type: ~~this.props.params.type,
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: {},
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            value: '',
            amountAll4: 0
            // distributor:JSON.parse(window.sessionStorage.getItem('distributor'))
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
        this.goView = this.goView.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    print = () => {

    };

    toFixed(d, n) {
        var s = n + "";
        if (!d) d = 0;
        if (s.indexOf(".") == -1) s += ".";
        s += new Array(d + 1).join("0");
        if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
            var s = "0" + RegExp.$2, pm = RegExp.$1, a = RegExp.$3.length, b = true;
            if (a == d + 2) {
                a = s.match(/\d/g);
                if (parseInt(a[a.length - 1]) > 4) {
                    for (var i = a.length - 2; i >= 0; i--) {
                        a[i] = parseInt(a[i]) + 1;
                        if (a[i] == 10) {
                            a[i] = 0;
                            b = i != 1;
                        } else break;
                    }
                }
                s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

            }
            if (b) s = s.substr(1);
            return (pm + s).replace(/\.$/, "");
        }
        return this + "";
    };


    /*获取列表数据*/
    initData() {
        let id = this.props.params.id;
        var realQuantityAll = 0;
        var amountAll = 0;
        var amountAll2 = 0;
        var amountAll3 = 0;
        var amountAll4 = 0; //扣点金额合计
        var returnaddress = "";
        var returnlinkman = "";
        var returnphone = "";
        const data = JSON.parse(window.sessionStorage.getItem('returngoodsprint'));
        if (data.gobackType != 'BPQ') {
            returnaddress = data.printAddress;
            returnlinkman = data.printLinkman;
            returnphone = data.printPhone;
        } else {
            returnaddress = "浙江省嘉兴市秀洲区中山西路2777号浙江天正智能电器有限公司";
            returnlinkman = "年介拽";
            returnphone = "15868072358";
        }
        for (let i = 0; i < data.lineList.length; i++) {
            data.lineList[i].id = i + 1;
            // realQuantityAll += data.lineList[i].gobackCount;
            realQuantityAll += data.lineList[i].realQuantity;
            amountAll += data.lineList[i].discountPrice;
            amountAll2 += data.lineList[i].discountMoney;
            data.lineList[i].discountPrice = data.lineList[i].discountPrice.toFixed(6);
            data.lineList[i].discountMoney = (data.lineList[i].discountPrice * data.lineList[i].realQuantity + 0.0000001).toFixed(2);
            //这是一个比较笨的方法，通过将小数乘以它的小数位数的10倍值，使其成为整数，通过整数的精确度方法四舍五入，然后在乘回原来的小数位
            //data.lineList[i].discountMoney = Math.round(data.lineList[i].discountPrice * data.lineList[i].realQuantity * 100 + 0.0000001) / 100;
            /*//解决tofixed在谷歌火狐中不兼容，四舍五入时5不进问题 (还有问题)
            var fixNum =(data.lineList[i].discountPrice * data.lineList[i].realQuantity+1).toFixed(2);
            data.lineList[i].discountMoney = new Number(fixNum - 1).toFixed(2);//四舍五入之后减1，再四舍*/
            amountAll3 = amountAll3 + Number(data.lineList[i].discountMoney);
            amountAll4 = amountAll4 + (data.lineList[i].sellPrice * data.lineList[i].realQuantity * data.lineList[i].refunds / 100);
        }
        var x = amountAll3.toFixed(2);
        var y = amountAll4.toFixed(2);
        var data1 = [...data.lineList];
        data1.push({
            id: 99999999,
            taxCode: '合计:',
            realQuantity: realQuantityAll,
            discountMoney: x
        });
        this.setState({
            rows: data1,
            resultData: data,
            amountAll4: y,
            returnaddress: returnaddress,
            returnlinkman: returnlinkman,
            returnphone: returnphone
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {/*distributor, */rows, total, searchObj, resultData, type} = this.state;
        let tableViewProps = "";
        if (resultData.returnTypeName == '已开票-红字证明单') {
            tableViewProps = {
                loading: false,//更新表格数据中
                rowKey: 'id',
                pageParam: false,
                // pageParam: {
                //   total: total,
                //   current: searchObj.p,//当前页码
                //   pageSize: searchObj.s,//当前分页数
                //   onChange: this.pageChange
                // },
                columns: [

                    {
                        title: '物料编码',
                        dataIndex: 'objCode'
                    },
                    {
                        title: '产品名称',
                        dataIndex: 'middleCat'
                    },
                    {
                        title: '型号规格',
                        dataIndex: 'objDescription'
                    },
                    {
                        title: '税率',
                        dataIndex: 'taxCode'
                    },
                    {
                        title: '数量',
                        dataIndex: 'realQuantity'
                    },
                    {
                        title: '单位',
                        dataIndex: 'unit',
                        render: (text, record, index) => {
                            return <div>{text == 'EA' ? '只' : text}</div>
                        }
                    },
                    {
                        title: '价格(含税)',
                        dataIndex: 'discountPrice',
                        // render: (text,record,index) => {
                        //   return <div>{record.discountPrice.tofixed(2) || 0}</div>
                        // }
                    },
                    {
                        title: '金额',
                        dataIndex: 'discountMoney'
                    },
                    {
                        title: '发票号-序号/日期',
                        dataIndex: 'invoiceContent'
                    }
                ],
                paginationHide: true,
                rows
            };
        } else {
            tableViewProps = {
                loading: false,//更新表格数据中
                rowKey: 'id',
                pageParam: false,
                // pageParam: {
                //   total: total,
                //   current: searchObj.p,//当前页码
                //   pageSize: searchObj.s,//当前分页数
                //   onChange: this.pageChange
                // },
                columns: [

                    {
                        title: '物料编码',
                        dataIndex: 'objCode'
                    },
                    {
                        title: '产品名称',
                        dataIndex: 'middleCat'
                    },
                    {
                        title: '型号规格',
                        dataIndex: 'objDescription'
                    },
                    {
                        title: '税收编码',
                        dataIndex: 'shuiCoce'
                    },
                    {
                        title: '税率',
                        dataIndex: 'taxCode'
                    },
                    {
                        title: '数量',
                        dataIndex: 'realQuantity'
                    },
                    {
                        title: '单位',
                        dataIndex: 'unit',
                        render: (text, record, index) => {
                            return <div>{text == 'EA' ? '只' : text}</div>
                        }
                    },
                    {
                        title: '价格(含税)',
                        dataIndex: 'discountPrice',
                        // render: (text,record,index) => {
                        //   return <div>{record.discountPrice.tofixed(2) || 0}</div>
                        // }
                    },
                    {
                        title: '金额',
                        dataIndex: 'discountMoney'
                    }
                ],
                paginationHide: true,
                rows
            };
        }

        const h1 = {width: '100%', textAlign: 'center'}
        const shiwu = {textAlign: 'center'}
        const top = {width: '100%', textAlign: 'center', position: 'relative'}
        const printDate = moment(new Date()).format('YYYY/MM/DD');
        return (
            <div style={{padding: '20px', lineHeight: '30px'}}>

                <h1 style={h1}>退货申请</h1>
                <p>{resultData.orgId == '82' ? '浙江天正电气股份有限公司' : resultData.orgId == '86' ? '上海天毅行智能电气有限公司' : ''}</p>
                <p> 经与贵司协商并结合贵司退货政策，我公司（{resultData.purchaseName}）确认此次申请需办理退货的相关产品明细如下：</p>
                <p>退单号：{resultData.orderNumber}</p>
                <p>退单类型：{resultData.qualityBusiness == 'Q' ? '质量退货' : resultData.qualityBusiness == 'B' ? '商务退货' : '-'}  &nbsp;&nbsp;&nbsp; 所属渠道：{resultData.channelName}</p>
                <div className='yourClass'><TableView {...tableViewProps} /></div>
                <p>我公司承诺在5日内按照退货申请类型提供此次退货所需的相关单据，逾期或未全部提供的，则视同放弃退货申请，请贵司将相关产品原路退回我公司。本次提供资料如下：</p>
                <p> □ {resultData.returnTypeName || ''}</p>
                <p style={{display: resultData.returnTypeName == '未开票退换货处理' ? 'block' : 'none'}}> 将提供：退货申请原件</p>
                <p style={{display: resultData.returnTypeName == '已开票-红字证明单' ? 'block' : 'none'}}> 将提供：与本次申请内容相一致的“红字增值税专用发票信息表”（简称“红字通知单”）、退货申请原件</p>
                <p style={{display: resultData.returnTypeName == '已开票-承担增值税' ? 'block' : 'none'}}> 将提供：
                    退货协议、退货回执确认函原件</p>
                <p style={{display: resultData.returnTypeName == '已开票-回购' ? 'block' : 'none'}}> 将提供：回购协议、增值税专用发票、退货申请原件</p>
                <p>{'　'}</p>
                <p> 按照贵司退货政策，此次退货我公司愿意承担退货损失金额{this.state.amountAll4 || 0}元，由贵司开具相应发票；注：此笔费用单独核算，与上述退货金额无关。</p>
                <p>{'　'}</p>
                <p> 我公司确认上述内容并选择将相关材料寄往以下地址：</p>
                <p> {this.state.returnaddress}</p>
                <p> 联系人:{this.state.returnlinkman}</p>
                <p> 联系电话:{this.state.returnphone}</p>
                <p>{'　'}</p>
                <div><p style={{textAlign: 'right'}}>退货单位 (盖章: 公章或财务章)</p>
                    <p style={{textAlign: 'right', marginTop: '25px'}}>________年 ____月 ____日</p></div>
            </div>
        )
    }
}

export default ReturnGoodsPrint;


// WEBPACK FOOTER //
// ./src/routes/print/returnGoodsPrint.js